import { Icon } from "./Icon"

import styles from "./StatusIcon.module.scss"

import type { StatusIconProps } from "."

export const StatusIcon = (props: StatusIconProps) => (
  <div className={styles.container} data-status-icon={props.status}>
    {props.children && (
      <span className={styles.children}>{props.children}</span>
    )}
    <Icon {...props} />
  </div>
)
